import { Pin } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTogglePinNote } from "@/lib/api";

// CSR-1885 — the pushpin control shared by both timeline surfaces (the insured
// Overview timeline card and the Policy Activities tab card). Pinning is global
// and works on all notes, including read-only NowCerts notes, so this is shown
// on every note card regardless of source. Isolating the useTogglePinNote
// (useMutation) dependency here keeps it out of non-note cards.
interface Props {
  noteId: string;
  pinned: boolean;
  testId: string;
}

export function NotePinButton({ noteId, pinned, testId }: Props) {
  const togglePin = useTogglePinNote();
  return (
    <button
      type="button"
      onClick={() => togglePin.mutate({ noteId, pinned: !pinned })}
      disabled={togglePin.isPending}
      className="p-1 hover:bg-muted rounded cursor-pointer disabled:opacity-50"
      aria-label={pinned ? "Unpin note" : "Pin to top"}
      title={pinned ? "Unpin" : "Pin to top"}
      data-testid={testId}
    >
      <Pin
        className={cn(
          "w-3.5 h-3.5",
          pinned ? "fill-blue-600 text-blue-600" : "text-muted-foreground",
        )}
      />
    </button>
  );
}
